module.exports = __webpack_public_path__ + "static/img/mu.b111c44a.svg";